import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const normalizeUrl = (url: string | undefined) => {
  if (!url) {
    throw new Error("url is not configured");
  }
  return url.replace(/\/$/, "");
};
